import { gql } from '@apollo/client';
import { NOTIFICATION_FIELDS } from '../queries/notification.query';

export const M_MARK_NOTIFICATION_READ = gql`
  mutation markNotificationRead($input: InputId!) {
    markNotificationRead(input: $input) { message }
  }
`;

export const M_MARK_ALL_NOTIFICATIONS_READ = gql`
  mutation markAllNotificationsRead {
    markAllNotificationsRead { message }
  }
`;

export const M_ARCHIVE_NOTIFICATION = gql`
  mutation archiveNotification($input: InputId!) {
    archiveNotification(input: $input) { message }
  }
`;

export const M_UPSERT_NOTIFICATION_DRAFT = gql`
  ${NOTIFICATION_FIELDS}
  mutation upsertNotificationDraft($input: InputNotificationDraftUpsert!) {
    upsertNotificationDraft(input: $input) { ...NotificationFields }
  }
`;

export const M_PUBLISH_NOTIFICATION = gql`
  ${NOTIFICATION_FIELDS}
  mutation publishNotification($input: InputNotificationPublish!) {
    publishNotification(input: $input) { ...NotificationFields }
  }
`;

export const M_CANCEL_NOTIFICATION = gql`
  mutation cancelNotification($input: InputId!) {
    cancelNotification(input: $input) { message }
  }
`;
